import { gql } from '@apollo/client';

import SellerInputFragment from '../fragments/sellerInputFragment';

const createSellerInputWithTrackingDataFromCookies = gql`
  mutation CreateSellerInputWithTrackingDataFromCookies(
    $input: OdProtosReceptionServices_CreateSellerInputRequestInput!
  ) {
    reception {
      createSellerInputWithTrackingDataFromCookies(input: $input) {
        sellerInput {
          analyticsMetadata {
            addressEntry {
              product
              url
            }
          }
          ...SellerInputFragment
        }
      }
    }
  }
  ${SellerInputFragment}
`;

export default createSellerInputWithTrackingDataFromCookies;
